import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DataTableService } from '../../../service/datatable.service';
import { CommonService } from '../../../service/common.service';
import { FranchiseService } from '../../../service/franchise.service';
import Swal from 'sweetalert2';
import { PurchaseOrderService } from '../../../service/purchase-order.service';
import { ToasterService } from 'angular2-toaster';
import { AuthenticationService } from '../../../service/authentication.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-received-purchase-orders',
  templateUrl: './received-purchase-orders.component.html',
  styleUrls: ['./received-purchase-orders.component.scss']
})

export class ReceivedPurchaseOrdersComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();

  currentUser: any = null;
  allPO: any = [];
  roleUser = '';
  showBillCreate: boolean = false;
  selectedTab = 'all';
  franchiseData: any = {};
  isSalesRep = false;
  disable = false;
  selectedPO: any = null;
  showPOModal: boolean = false;
  copiedField: string = '';

  private readonly STATUS_MAPPING = {
    1: { name: 'New', class: 'badge badge-success' },
    2: { name: 'Closed', class: 'badge badge-info' },
    3: { name: 'Reject', class: 'badge badge-danger' },
    4: { name: 'Revised', class: 'badge badge-warning' },
  };

  private readonly API_ENDPOINTS = {
    all: 'purchase-order/received/all',
    new: 'purchase-order/received/new',
    reject: 'purchase-order/received/reject',
    revised: 'purchase-order/received/revised',
    closed: 'purchase-order/received/closed'
  };

  private readonly REJECTION_CODES = [
    {
      category: 'Item Issues',
      codes: [
        { code: 'I1', description: 'Invalid Item Cost', ackResponse: 'IA' },
        { code: 'I3', description: 'Out of Stock', ackResponse: 'IR' },
        { code: 'I4', description: 'Bad SKU', ackResponse: 'IR' },
        { code: 'I5', description: 'Product Has Been Discontinued', ackResponse: 'IR' },
        { code: 'IB', description: 'Backorder', ackResponse: 'IR' }
      ]
    },
    {
      category: 'Order Issues',
      codes: [
        { code: 'O1', description: 'Duplicate Order', ackResponse: 'IR' },
        { code: 'O2', description: 'Order Info Missing', ackResponse: 'IR' }
      ]
    },
    {
      category: 'Shipping Issues',
      codes: [
        { code: 'S1', description: 'Cannot Ship USPS', ackResponse: 'IR' },
        { code: 'S2', description: 'Cannot Ship to PO Box', ackResponse: 'IR' },
        { code: 'S3', description: 'Cannot Ship to Country', ackResponse: 'IR' },
        { code: 'S4', description: 'Invalid Method of Shipment', ackResponse: 'IR' },
        { code: 'S5', description: 'Bad Address', ackResponse: 'IR' },
        { code: 'S6', description: 'Cannot Ship as Ordered', ackResponse: 'IR' }
      ]
    },
    {
      category: 'Other Issues',
      codes: [
        { code: 'R3', description: 'Unit of Issue (UOM)', ackResponse: 'IA' }
      ]
    }
  ];

   constructor(private _dtService: DataTableService,
     private commonService: CommonService,
     private franchiseService: FranchiseService,
     private authService: AuthenticationService,
     private _poService: PurchaseOrderService,
     private toasterService: ToasterService
   ) {}

   ngOnInit() {
     this.authService.userData.subscribe((res) => {
       this.currentUser = res['id'];
     });

     this.commonService.introType.next('purchase_orders_general');
     this.franchiseData = this.franchiseService.franchiseData.getValue();

     this.roleUser = this.franchiseData['role']['original_name'];
     if (this.roleUser == 'Accountant' || this.roleUser == 'Admin' || this.roleUser == 'Estimator HOD' || this.roleUser == 'Estimator') {
       this.showBillCreate = true;
     } else if (this.roleUser == 'Sales Rep') {
       this.isSalesRep = true;
     }

     this.getAllPO();
   }

   getAllPO = () => {
     const that = this;
     this.dtOptions = {
       dom: "<'row'<'col-sm-12 col-md-4'l><'col-sm-12 col-md-4 top'i><'col-sm-12 col-md-4 top'f>>" +
       "<'row'<'col-sm-12'tr>>" +
       "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
       pagingType: 'full_numbers',
       pageLength: 25,
       lengthMenu: [10, 25, 50, 100],
       serverSide: true,
       processing: true,
       language: {
         searchPlaceholder: 'Search...',
         search: ''
       },
       ajax: (dataTablesParameters: any, callback) => {
         const apiEndpoint = this.getApiEndpoint(that.selectedTab);
         const data = { type: that.selectedTab };

         this._dtService.getTableData(dataTablesParameters, apiEndpoint, data).subscribe(
           res => {
             this.allPO = res['data']['original']['data'];
             callback({
               recordsTotal: res['data']['original']['recordsTotal'],
               recordsFiltered: res['data']['original']['recordsFiltered'],
               data: []
             });
           },
           error => {
             console.error('API Error:', error);
             this.allPO = [];
             callback({
               recordsTotal: 0,
               recordsFiltered: 0,
               data: []
             });
           }
         );
       },
       order: [],
       columns: [
         { name: 'beg_date' },
         { name: 'beg_purchase_order_number' },
         { name: 'status' },
         { data: null, searchable: false, orderable: false }
       ]
     };
   }

   getApiEndpoint(tabType: string): string {
     return this.API_ENDPOINTS[tabType] || this.API_ENDPOINTS.all;
   }

   getStatusName(status: number): string {
     return this.STATUS_MAPPING[status].name || 'Unknown';
   }

   getStatusClass(status: number): string {
     return this.STATUS_MAPPING[status].class || 'badge badge-secondary';
   }

   formatDate(dateString: string): string {
     if (!dateString || dateString.length !== 8) {
       return '';
     }

     try {
       const year = dateString.substring(0, 4);
       const month = dateString.substring(4, 6);
       const day = dateString.substring(6, 8);

       const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

       if (isNaN(date.getTime())) {
         return dateString;
       }

       return date.toLocaleDateString('en-US');
     } catch (error) {
       return dateString;
     }
   }

   storePONumber(poNumber: string) {
     if (poNumber) {
       localStorage.setItem('selected_po_number', poNumber);
       console.log('PO Number stored in localStorage:', poNumber);
     }
   }

   changedTab(tabName: string) {
     this.selectedTab = tabName;
     this.rerender();
   }

   ngAfterViewInit() {
     const configStatus = this.commonService.configStatus.getValue();
     if (Object.keys(configStatus).length === 0) {
       this.commonService.getConfigStatusData().subscribe(res => {
         this.commonService.configStatus.next(res);
         this.dtTrigger.next();
       });
     } else {
       this.dtTrigger.next();
     }
   }

   ngOnDestroy() {
     this.dtTrigger.unsubscribe();
   }

   exportToExcel = (exportType: 'CSV' | 'XLSX') => {
     const type = this.selectedTab;
     const params = {
       columns: [
         { name: 'beg_date' },
         { name: 'beg_purchase_order_number' },
         { name: 'status' },
         { data: null, searchable: false, orderable: false }
       ],
       order: [],
       type: type,
       search: { value: "", regex: false },
       start: 0,
     };

     this._poService.getPurchaseOrderAllReceviedReport(params).subscribe((res) => {
       const data = res.data.original.data || [];
       const exportData = data.map(item => ({
         "PO Created On": this.formatDate(item.beg_date) || '',
         "PO Number": item.beg_purchase_order_number || '',
         "Status": this.getStatusName(item.status)
       }));

       const worksheet = XLSX.utils.json_to_sheet(exportData);
       const workbook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

       const fileName = `Received Purchase Order Report ${type}.${exportType.toLowerCase()}`;
       XLSX.writeFile(workbook, fileName, exportType === 'CSV' ? undefined : { bookType: 'xlsx', type: 'buffer' });
     });
   }

   rerender = (): void => {
     this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
       dtInstance.destroy();
       this.dtTrigger.next();
     });
   }

   viewPODetails = (po: any) => {
     this.selectedPO = po;
     this.showPOModal = true;
   }

   closePOModal = () => {
     this.selectedPO = null;
     this.showPOModal = false;
     this.copiedField = '';
   }

   copyToClipboard = (text: string, fieldName: string) => {
     const textToCopy = text || '';

     if (typeof navigator !== 'undefined' && 'clipboard' in navigator && window.isSecureContext) {
       (navigator as any).clipboard.writeText(textToCopy).then(
         () => this.handleCopySuccess(fieldName),
         () => this.fallbackCopyToClipboard(textToCopy, fieldName)
       );
     } else {
       this.fallbackCopyToClipboard(textToCopy, fieldName);
     }
   }

   getItemStatus(item: any): number {
      return item.STATUS || item.status || 0;
    }

   calculateLineTotal(unitPrice: any, quantity: any): string {
     if (!unitPrice || !quantity) return '0.00';
     const price = parseFloat(unitPrice) || 0;
     const qty = parseInt(quantity) || 0;
     const total = price * qty;
     return total.toFixed(2);
   }

   formatCurrency(value: any): string {
     if (!value) return '0.00';
     const numValue = parseFloat(value) || 0;
     return numValue.toFixed(2);
   }

   copyLineTotal(unitPrice: any, quantity: any): void {
     const total = this.calculateLineTotal(unitPrice, quantity);
     this.copyToClipboard(`$${total}`, 'Total Line Amount');
   }

   copyCurrencyValue(value: any, fieldName: string): void {
     const formattedValue = `$${this.formatCurrency(value)}`;
     this.copyToClipboard(formattedValue, fieldName);
   }

   private handleCopySuccess = (fieldName: string) => {
     this.copiedField = fieldName;
     this.toasterService.pop('success', `${fieldName} copied to clipboard!`);
     setTimeout(() => this.copiedField = '', 2000);
   }

   private fallbackCopyToClipboard = (text: string, fieldName: string) => {
     const textArea = document.createElement('textarea');
     textArea.value = text;
     textArea.style.cssText = 'position: fixed; left: -999999px; top: -999999px;';
     document.body.appendChild(textArea);
     textArea.focus();
     textArea.select();

     try {
       document.execCommand('copy');
       this.handleCopySuccess(fieldName);
     } catch (err) {
       this.toasterService.pop('error', 'Failed to copy to clipboard');
     } finally {
       textArea.remove();
     }
   }

   rejectPurchaseOrder = (id: any) => {
     const optionsHtml = this.buildRejectionOptionsHtml();

     Swal.fire({
       title: 'Reject Purchase Order',
       html: `
         <div style="text-align: left; margin-bottom: 15px;">
           <label for="reasonCode" style="display: block; margin-bottom: 5px; font-weight: 600;">Select Rejection Reason:</label>
           <select id="reasonCode" class="swal2-input" style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px;">
             <option value="">-- Select Reason --</option>
             ${optionsHtml}
           </select>
         </div>
       `,
       showCancelButton: true,
       confirmButtonColor: '#dc3545',
       cancelButtonColor: '#6c757d',
       confirmButtonText: 'Yes, Reject It!',
       cancelButtonText: 'Cancel',
       showLoaderOnConfirm: true,
       preConfirm: () => this.handleRejectionSubmit(id),
     }).then((result) => {
       if (result.value) {
         this.toasterService.pop('success', 'Purchase Order has been rejected successfully');
       }
     });
   }

   private handleRejectionSubmit = (id: any) => {
     const reasonCodeSelect = document.getElementById('reasonCode') as HTMLSelectElement;
     const reasonCode = reasonCodeSelect.value;

     if (!reasonCode) {
       Swal.showValidationMessage('Please select a rejection reason');
       return false;
     }

     const reasonDescription = this.getRejectionReasonDescription(reasonCode);

     const rejectionData = {
       id,
       reason_description: reasonDescription
     };

     return this._poService.rejectPO(rejectionData).toPromise()
       .then((res) => {
         if (res['data'] || res['message']) {
           this.toasterService.pop('success', `Purchase Order rejected with reason: ${reasonDescription}`);
           this.rerender();
           return rejectionData;
         } else {
           this.toasterService.pop('error', 'Failed to update purchase order status');
           return false;
         }
       })
       .catch((error) => {
         this.toasterService.pop('error', error['error']['message'] || 'Failed to update purchase order status');
         return false;
       });
   }

   private getRejectionReasonDescription(code: string): string {
     for (const category of this.REJECTION_CODES) {
       const foundCode = category.codes.find(item => item.code === code);
       if (foundCode) {
         return `${foundCode.code} ${foundCode.description}`;
       }
     }
     return code; // Return just the code if description not found
   }

   getRejectionReasonCodes = () => this.REJECTION_CODES;

   buildRejectionOptionsHtml(): string {
     let optionsHtml = '';

     this.REJECTION_CODES.forEach(category => {
       optionsHtml += `<optgroup label="${category.category}">`;
       category.codes.forEach(item => {
         optionsHtml += `<option value="${item.code}">${item.code} - ${item.description}</option>`;
       });
       optionsHtml += '</optgroup>';
     });

     return optionsHtml;
   }
 }
